controllers.controller('EmailVerificationController', [
    '$scope', '$state', 'LocaleService', 'config', 'API', 'UserService', '$q', 'ionicToast',
    'constants', 'Validator', 'Utils', 'LoginService', 'Storage', '$ionicLoading', 'ErrorService',
    function ($scope, $state, LocaleService, Config, API, UserService, $q, ionicToast,
              Const, Validator, Utils, LoginService, Storage, $ionicLoading, ErrorService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.user = UserService.get();

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.verification = {
            code: undefined
        };

        $scope.ticketSent = false;

        $scope.validator = Validator.getPattern;

        $scope.config = Config;

        $scope.verify = function () {
            var request = {
                code: Number($scope.verification.code)
            }

            $ionicLoading.show();
            return API.emailVerificationCode(request)
                .then(Utils.wait(500))
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();
                    $scope.user.emailVerificationRequired = false;
                    // continue flow
                    return $state.go('root.app.assets', {cache: false});
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                    $scope.modal.state = true;
                })

        }

        $scope.resend = function () {
            $ionicLoading.show();
            return API.emailVerificationCodeResend()
                .then(Utils.wait(500))
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();
                    $scope.user.emailVerificationRequired = false;
                    $scope.modal.textTitle = LocaleService.translation.resendText;
                    $scope.modal.actionText = LocaleService.translation.continue;
                    $scope.modal.isError = false;
                    $scope.modal.isProcess = false;
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    console.warn(error);
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                    $scope.modal.state = true;
                })
        }

        $scope.sendTicket = function () {
            $ionicLoading.show();
            var request = {
                type: Const.ticketTypes.emailVerification,
                subject: 'Email Verification failed - change email',
                description: 'Email Verification failed - change email'
            }
            return API.createTicket(request)
                .then(Utils.wait(500))
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();
                    $scope.ticketSent = true;
                })
                .catch(function (error) {
                    console.warn(error);
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                    $scope.modal.state = true;
                })
        }

        $scope.logout = function () {
            Storage.remove('registration');
            $scope.loadingMessage = LocaleService.translation.logging_out;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            return LoginService.logout()
                .then(function () {
                    $ionicLoading.hide();
                    if ($scope.redirectOnLogoutURL) {
                        window.location.replace($scope.redirectOnLogoutURL + "?lang=" + ($scope.lang || 'en'));
                    } else {
                        $state.go('welcome');
                    }
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    if ($scope.redirectOnLogoutURL) {
                        window.location.replace($scope.redirectOnLogoutURL + "?lang=" + ($scope.lang || 'en'));
                    } else {
                        $state.go('welcome');
                    }
                });
        };


        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'EmailVerificationController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

    }]);
